<template>
  <ux-form
    ref="form"
    width="450px"
    :data="formData"
    :colon="true"
    :rules="rules"
    data-automation="addApply"
    @close="close"
    @confirm="confirm"
    label-width="80px"
  >
    <ux-form-item :label="$t('HT.advancedService.serviceName')" required prop="serviceName">
      <ux-input
        v-model="formData.serviceName"
        :maxlength="32"
        :placeholder="$t('HT.pleaseInput')+$t('HT.advancedService.serviceName')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.advancedService.serviceCode')" required prop="serviceCode">
      <ux-input
        v-model="formData.serviceCode"
        :maxlength="32"
        :placeholder="$t('HT.pleaseInput')+$t('HT.advancedService.serviceCode')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.advancedService.serviceType')" required prop="serviceType">
      <ux-select v-model="formData.serviceType" clearable :options="serviceTypeList"  :props="{label:'name',value:'name'}" :placeholder="$t('HT.pleaseSelect')+$t('HT.advancedService.serviceType')"></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.advancedService.vendor')" required prop="vendor">
      <ux-select v-model="formData.vendor" clearable :options="vendorList"  :props="{label:'name',value:'name'}" :placeholder="$t('HT.pleaseSelect')+$t('HT.advancedService.vendor')"></ux-select>
    </ux-form-item>
    <ux-form-item :label="$t('HT.remark')"  prop="serviceDesc">
      <ux-input
        v-model="formData.serviceDesc"
        type="textarea"
        :maxlength="200"
        :placeholder="$t('HT.pleaseInput')+$t('HT.remark')"
      ></ux-input>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          serviceName: '',
          serviceCode: '',
          serviceType: '',
          vendor: '',
          serviceDesc: '',
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: {
        serviceName: [
          { required: true, message: this.$t('HT.pleaseInput') + this.$t('HT.advancedService.serviceName'), trigger: 'blur' }
        ],
        serviceCode: [
          { required: true, message: this.$t('HT.pleaseInput') + this.$t('HT.advancedService.serviceCode'), trigger: 'blur' }
        ],
        serviceType: [
          { required: true, message: this.$t('HT.pleaseSelect') + this.$t('HT.advancedService.serviceType'), trigger: 'blur' }
        ],
        vendor: [
          { required: true, message: this.$t('HT.pleaseSelect') + this.$t('HT.advancedService.vendor'), trigger: 'blur'}
        ]
        
      },
      serviceTypeList:[],
      vendorList:[],
    };
  },
mounted() {
  this.getAllServiceType()
  this.getAllServiceVendor()
},
  methods: {
    async getAllServiceType() {
      let {code,data}=await this.$api.advancedService.getAllServiceType();
      code===10000&&(this.serviceTypeList=data);
    },
    async getAllServiceVendor() {
      let {code,data}=await this.$api.advancedService.getAllServiceVendor();
      code===10000&&(this.vendorList=data);
    },
    
    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.formData);
        }
      });
    }
  }
};
</script>
